import { FC, useState } from 'react';
import {
  Box,
  Checkbox,
  FormControlLabel,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import RenderInWindow from './RenderInWindow';

interface DebugWindowProps {
  data: string[];
}

const DebugWindow: FC<DebugWindowProps> = ({ data }) => {
  const { state } = useLocation();
  const [isChecked, setIsChecked] = useState(false);
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(event.target.checked);
  };

  return (
    <Box>
      <FormControlLabel
        control={
          <Checkbox checked={isChecked} onChange={handleCheckboxChange} />
        }
        label={isChecked ? 'Debug Mode On' : 'Debug Mode Off'}
      />
      <RenderInWindow open={isChecked} setOpen={setIsChecked}>
        <Typography variant="h3">{`${state.title} Debug Log`}</Typography>
        {data.length > 0 && (
          <List className="new-window-list">
            {data.map((output, index) => (
              // @ts-ignore: TODO: id system maybe uuid
              <ListItem key={output + state.id}>
                <ListItemText primary={`[${index + 1}] ${output}`} />
              </ListItem>
            ))}
          </List>
        )}
      </RenderInWindow>
    </Box>
  );
};

export default DebugWindow;
